import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { ToggleButtonWithYesNo } from "../../AllButton/ToggleButtonReuse";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_new_subscription_for_vendor,
  get_new_subscription_for_vendor,
} from "../../../../../../store/actions/authAction";
import Media from "react-media";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { Button, Image } from "react-bootstrap";
import MassCompletion from "../../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MassCompletion";
import { propTypes } from "react-bootstrap/esm/Image";

export const EditCasualDiningOrdering = (props) => {
  const history = useHistory();
  const [state, setState] = useState({
    orderingTakeAwayService: false,
    orderingCurbSideService: false,
    orderingDineService: false,
    orderingSkipLineService: false,
    orderingAtMySeatService: false,
    orderingCateringBanquetService: false,
    orderingHomeDeliveryService: false,
    orderingMaintainBankAccountService: false,
    orderingGeneralTaxService: false,
    casualFineDiningTakeAway: false,
    casualFineDiningCurbsideDelivery: false,
    casualFineDiningDineIn: false,
    casualFineDiningSkipline: false,
    casualFineDiningAtMySeat: false,
    casualFineDiningCateringAndBanquet: false,
    casualFineDiningHomeDelivery: false,
    casualFineDiningBankAccounts: false,
    casualFineDiningGeneralSettings: false,
    massCompletion: false,
    massCompletionTime: "",
    orderingsteps:3,
  });

  const OrderingStepOptions = [
   {title:"3 Step Process",value: 3 } ,
    // {title:"5 Step Process",value: 5 } ,
     {title:"7 Step Process",value: 7 } ,

  ]

  /**************************************
   * @DESC TAKEAWAY ACTION
   ***************************************/
  const onClickTakeAwayService = (e) => {
    if (state.casualFineDiningTakeAway === true) {
      setState({
        ...state,
        casualFineDiningTakeAway: !state.casualFineDiningTakeAway,
      });
    } else {
      history.push("/edit-ordering-subscription/takeaway");
    }
  };

  /**************************************
   * @DESC CURBSIDE ACTION
   ***************************************/
  const onClickCurbsideDeliveryService = (e) => {
    if (state.casualFineDiningCurbsideDelivery === true) {
      setState({
        ...state,
        casualFineDiningCurbsideDelivery:
          !state.casualFineDiningCurbsideDelivery,
      });
    } else {
      history.push("/edit-ordering-subscription/curbside");
    }
  };

  /**************************************
   * @DESC DINE IN ACTION
   ***************************************/
  const onClickDineInService = (e) => {
    if (state.casualFineDiningDineIn === true) {
      setState({
        ...state,
        casualFineDiningDineIn: !state.casualFineDiningDineIn,
      });
    } else {
      history.push("/edit-ordering-subscription/dinein");
    }
  };

  /**************************************
   * @DESC SKIP THE LINE ACTION
   ***************************************/
  const onClickSkipTheLineService = (e) => {
    if (state.casualFineDiningSkipline === true) {
      setState({
        ...state,
        casualFineDiningSkipline: !state.casualFineDiningSkipline,
      });
    } else {
      history.push("/edit-ordering-subscription/skiptheline");
    }
  };

  /**************************************
   * @DESC At My Seat ACTION
   ***************************************/
  const onClickAtMySeatService = (e) => {
    if (state.casualFineDiningAtMySeat === true) {
      setState({
        ...state,
        casualFineDiningAtMySeat: !state.casualFineDiningAtMySeat,
      });
    } else {
      history.push("/edit-ordering-subscription/atmyseat");
    }
  };

  /**************************************
   * @DESC Catering Banquet ACTION
   ***************************************/
  const onClickCateringAndBanquetService = (e) => {
    if (state.casualFineDiningCateringAndBanquet === true) {
      setState({
        ...state,
        casualFineDiningCateringAndBanquet:
          !state.casualFineDiningCateringAndBanquet,
      });
    } else {
      history.push("/edit-ordering-subscription/catering-banquet");
    }
  };

  /**************************************
   * @DESC Home Delivery ACTION
   ***************************************/
  const onClickHomeDeliveryService = (e) => {
    if (state.casualFineDiningHomeDelivery === true) {
      setState({
        ...state,
        casualFineDiningHomeDelivery: !state.casualFineDiningHomeDelivery,
      });
    } else {
      history.push("/edit-ordering-subscription/home-delivery");
    }
  };

  /**************************************
   * @DESC Bank Account ACTION
   ***************************************/
  const onClickBankAccountsService = (e) => {
    if (state.casualFineDiningBankAccounts === true) {
      setState({
        ...state,
        casualFineDiningBankAccounts: !state.casualFineDiningBankAccounts,
      });
    } else {
      history.push("/edit-ordering-subscription/separate-bank-account");
    }
  };

  /**************************************
   * @DESC General Tax ACTION
   ***************************************/
  const onClickGeneralSettingsService = (e) => {
    if (state.casualFineDiningGeneralSettings === true) {
      setState({
        ...state,
        casualFineDiningGeneralSettings: !state.casualFineDiningGeneralSettings,
      });
    } else {
      if (
        props.subscriptionData &&
        (props?.subscriptionData?.take_away?.value ||
          props?.subscriptionData?.cubside_delivery?.value ||
          props?.subscriptionData?.dine_in_order?.value ||
          props?.subscriptionData?.catering_banquet?.value ||
          props?.subscriptionData?.home_delivery?.value ||
          props?.subscriptionData?.self_serve?.value ||
          props?.subscriptionData?.my_seat_table_order?.value)
      ) {
        history.push("/edit-ordering-subscription/order-general-taxes");
      } else {
        alert(
          "Please add atleast one service in ordering. ex: take away, cubside delivery, dine in order, catering banquet, home delivery"
        );
      }
    }
  };

  const onClickRedirectToOtherScreen = () => {
    let formData = {
      vendor_id: props?.auth?.user?.VendorUser?._id,
    };
    props.get_new_subscription_for_vendor(formData, onSuccessSubscription);
  };

  const onSuccessSubscription = () => {
    history.push({
      pathname: "/edit-ordering-subscription/order-general-taxes",
      state: { access: "edit" },
    });
  };

  const massCompletionToggle = (e) => {
    setState({
      ...state,
      massCompletion: !state.massCompletion,
    });
  };

  const onChangeMassCompletion = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setState({
      ...state,
      /********************************
       * @DESC Active Services
       *********************************/
      orderingTakeAwayService:
        props?.subscriptionData && props?.subscriptionData?.take_away?.value,
      orderingCurbSideService:
        props?.subscriptionData &&
        props?.subscriptionData?.cubside_delivery?.value,
      orderingDineService:
        props?.subscriptionData &&
        props?.subscriptionData?.dine_in_order?.value,
      orderingSkipLineService:
        props?.subscriptionData && props?.subscriptionData?.self_serve?.value,
      orderingAtMySeatService:
        props?.subscriptionData &&
        props?.subscriptionData?.my_seat_table_order?.value,
      orderingCateringBanquetService:
        props?.subscriptionData &&
        props?.subscriptionData?.catering_banquet?.value,
      orderingHomeDeliveryService:
        props?.subscriptionData &&
        props?.subscriptionData?.home_delivery?.value,
      orderingMaintainBankAccountService:
        props?.subscriptionData &&
        props?.subscriptionData?.maintain_separate_bank?.value,
      orderingGeneralTaxService:
        props?.subscriptionData &&
        props?.subscriptionData?.order_general?.value,
        orderingsteps:props?.subscription?.orderSteps,

      /*******************************************
       * @DESC Active Subscription Services Data
       *******************************************/
      casualFineDiningTakeAway:
        props?.subscriptionData && props?.subscriptionData?.take_away?.value,
      casualFineDiningCurbsideDelivery:
        props?.subscriptionData &&
        props?.subscriptionData?.cubside_delivery?.value,
      casualFineDiningDineIn:
        props?.subscriptionData &&
        props?.subscriptionData?.dine_in_order?.value,
      casualFineDiningSkipline:
        props?.subscriptionData && props?.subscriptionData?.self_serve?.value,
      casualFineDiningAtMySeat:
        props?.subscriptionData &&
        props?.subscriptionData?.my_seat_table_order?.value,
      casualFineDiningCateringAndBanquet:
        props?.subscriptionData &&
        props?.subscriptionData?.catering_banquet?.value,
      casualFineDiningHomeDelivery:
        props?.subscriptionData &&
        props?.subscriptionData?.home_delivery?.value,
      casualFineDiningBankAccounts:
        props?.subscriptionData &&
        props?.subscriptionData?.maintain_separate_bank?.value,
      casualFineDiningGeneralSettings:
        props?.subscriptionData &&
        props?.subscriptionData?.order_general?.value,
      massCompletion:
        props?.subscriptionData?.massCompletion?.value !== null &&
        props?.subscriptionData?.massCompletion?.value !== undefined
          ? props?.subscriptionData?.massCompletion?.value
          : false,
      massCompletionTime:
        props?.subscriptionData?.massCompletion?.massCompletionTime !== null &&
        props?.subscriptionData?.massCompletion?.massCompletionTime !==
          undefined
          ? props?.subscriptionData?.massCompletion?.massCompletionTime
          : "",
    });
  }, [props.subscriptionData]);

//   useEffect(()=> {
//  setState({...state,orderingsteps:props?.subscription?.orderSteps})
//   },[props?.subscription])

  // const onclick = (value) => (e) => {
  //   setCasualFineDining({
  //     ...casualFineDining,
  //     casualFineDining: !value,
  //   });
  //   // console.log(e, value);
  // };

  // const onclick = (i) => (event) => {
  //   setCasualFineDining(() => {
  //     casualFineDining[i] = !casualFineDining[i];
  //   });
  // };
 console.log(props.subscriptionData,"sub dataaaa");
  const orderingClickSubmitHandler = (e) => {
    let valueData = {
      // value:
      //   state.casualFineDiningTakeAway ||
      //   state.casualFineDiningCurbsideDelivery ||
      //   state.casualFineDiningDineIn ||
      //   state.casualFineDiningSkipline ||
      //   state.casualFineDiningAtMySeat ||
      //   state.casualFineDiningCateringAndBanquet ||
      //   state.casualFineDiningHomeDelivery ||
      //   state.casualFineDiningBankAccounts ||
      //   state.casualFineDiningGeneralSettings
      //     ? true
      //     : false,
      value: true,
      take_away: {
        value: state.casualFineDiningTakeAway,
      },
      cubside_delivery: {
        value: state.casualFineDiningCurbsideDelivery,
      },

      dineInOrder: {
        value: state.casualFineDiningDineIn,
      },
      home_delivery: {
        value: state.casualFineDiningHomeDelivery,
      },

      self_serve: {
        value: state.casualFineDiningSkipline,
      },
      atMySeat: {
        value: state.casualFineDiningAtMySeat,
      },

      catering_banquet: {
        value: state.casualFineDiningCateringAndBanquet,
      },
      maintain_separate_bank: {
        value: state.casualFineDiningBankAccounts,
      },
      order_general: {
        value: state.casualFineDiningGeneralSettings,
      },
      massCompletion: {
        value: state.massCompletion,
        massCompletionTime: state.massCompletionTime,
      },
      orderSteps : {
       value: state.orderingsteps
      },
    };
    const token = props.auth.user.accessToken;
    const subscriptionId = props.subscription._id;
    let formData = props.allSubscriptionsData;
    if (props.casualDiningService) {
      formData.casual_dining_status.ordering.value = valueData?.value;
      formData.casual_dining_status.ordering.take_away.value =
        valueData?.take_away?.value;
      formData.casual_dining_status.ordering.cubside_delivery.value =
        valueData?.cubside_delivery?.value;
      formData.casual_dining_status.ordering.dine_in_order.value =
        valueData?.dineInOrder?.value;
      formData.casual_dining_status.ordering.catering_banquet.value =
        valueData?.catering_banquet?.value;
      formData.casual_dining_status.ordering.home_delivery.value =
        valueData?.home_delivery?.value;
      formData.casual_dining_status.ordering.maintain_separate_bank.value =
        valueData?.maintain_separate_bank?.value;
      formData.casual_dining_status.ordering.order_general.value =
        valueData?.order_general?.value;
      formData.casual_dining_status.ordering.massCompletion.value =
        valueData?.massCompletion?.value;
      formData.casual_dining_status.ordering.massCompletion.massCompletionTime =
        valueData?.massCompletion?.massCompletionTime;
    } else if (props.fastFoodDiningService) {
      formData.fast_food_dining_status.ordering.value = valueData?.value;
      formData.fast_food_dining_status.ordering.take_away.value =
        valueData?.take_away?.value;
      formData.fast_food_dining_status.ordering.cubside_delivery.value =
        valueData?.cubside_delivery?.value;
      formData.fast_food_dining_status.ordering.self_serve.value =
        valueData?.self_serve?.value;
      formData.fast_food_dining_status.ordering.my_seat_table_order.value =
        valueData?.atMySeat?.value;
      formData.fast_food_dining_status.ordering.catering_banquet.value =
        valueData?.catering_banquet?.value;
      formData.fast_food_dining_status.ordering.home_delivery.value =
        valueData?.home_delivery?.value;
      formData.fast_food_dining_status.ordering.maintain_separate_bank.value =
        valueData?.maintain_separate_bank?.value;
      formData.fast_food_dining_status.ordering.order_general.value =
        valueData?.order_general?.value;
      formData.fast_food_dining_status.ordering.massCompletion.value =
        valueData?.massCompletion?.value;
      formData.fast_food_dining_status.ordering.massCompletion.massCompletionTime =
        valueData?.massCompletion?.massCompletionTime;
    } else if (props.multiDiningService) {
      formData.multi_service_business_status.ordering.value = valueData?.value;
      formData.multi_service_business_status.ordering.take_away.value =
        valueData?.take_away?.value;
      formData.multi_service_business_status.ordering.cubside_delivery.value =
        valueData?.cubside_delivery?.value;
      formData.multi_service_business_status.ordering.dine_in_order.value =
        valueData?.dineInOrder?.value;
      formData.multi_service_business_status.ordering.self_serve.value =
        valueData?.self_serve?.value;
      formData.multi_service_business_status.ordering.my_seat_table_order.value =
        valueData?.atMySeat?.value;
      formData.multi_service_business_status.ordering.home_delivery.value =
        valueData?.home_delivery?.value;
      formData.multi_service_business_status.ordering.catering_banquet.value =
        valueData?.catering_banquet?.value;
      formData.multi_service_business_status.ordering.maintain_separate_bank.value =
        valueData?.maintain_separate_bank?.value;
      formData.multi_service_business_status.ordering.order_general.value =
        valueData?.order_general?.value;
      formData.multi_service_business_status.ordering.massCompletion.value =
        valueData?.massCompletion?.value;
      formData.multi_service_business_status.ordering.massCompletion.massCompletionTime =
        valueData?.massCompletion?.massCompletionTime;
    }
    formData.orderSteps =valueData.orderSteps.value
    props.update_new_subscription_for_vendor(
      subscriptionId,
      formData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Ordering subscription changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/profile");
  };

  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledOne, setDisableOne] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledTwo, setDisableTwo] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledThree, setDisableThree] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledFour, setDisableFour] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledFive, setDisableFive] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledSix, setDisableSix] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledSeven, setDisableSeven] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );
  const [disabledEight, setDisableEight] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );

  useEffect(() => {
    if(props?.restaurantDetails?.pos?.restId && props?.restaurantDetails?.pos?.restId != "")
      setDisableSix(true);
  }, [props?.restaurantDetails])

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>

          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/profile"
              displayText="Back"
            />
            <br />
            <div className="col-12 col-md-8 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
              <div className="mb-4">
                <TopTextReusableComponent
                  headingText={
                    props.casualDiningService
                      ? "Casual / Fine Dining Ordering Options"
                      : props.fastFoodDiningService
                      ? "Fast Food, Cafe, Food Court and Other Order Setting"
                      : props.multiDiningService
                      ? "Multi Service Business"
                      : ""
                  }
                />
              </div>
              <br />
              {/* orderingTakeAwayService
orderingCurbSideService
orderingDineService
orderingSkipLineService
orderingAtMySeatService
orderingCateringBanquetService
orderingHomeDeliveryService
orderingMaintainBankAccountService
orderingGeneralTaxService */}
              <div className="row align-items-center pb-4 ml-1">
                <div className="col-4 col-md-7 col-lg-6 p-0">
                  <div className="f14-700">Takeaway Service Enabled</div>
                  <div class="f10-400 opacity5">
                    (Takeaway service will be default activated)
                  </div>
                </div>
                <div className="col-4 col-md-2 col-lg-3">
                  <ToggleButtonWithYesNo
                    activeClass={state.casualFineDiningTakeAway}
                    checkedBox={state.casualFineDiningTakeAway}
                    onChange={onClickTakeAwayService}
                    disabled={disabled}
                    extraClass="d-flex align-items-center"
                    extraYesNo="f12-500"
                  />
                </div>
                {/* <Media query="(min-width:991px)"> */}
                <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                  <div className="d-flex rightside-toggle-buttons-subscription-menu">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname: "/edit-ordering-subscription/takeaway",
                          state: { access: "view" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname: "/edit-ordering-subscription/takeaway",
                          state: { access: "edit" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  </div>
                </div>
                {/* </Media> */}
              </div>
              <div className="row align-items-center pb-4 ml-1">
                <div className="col-4 col-md-7 col-lg-6 p-0">
                  <div className="f14-700">Curbside Delivery Service</div>
                </div>
                <div className="col-4 col-md-2 col-lg-3">
                  <ToggleButtonWithYesNo
                    activeClass={state.casualFineDiningCurbsideDelivery}
                    checkedBox={state.casualFineDiningCurbsideDelivery}
                    onChange={onClickCurbsideDeliveryService}
                    disabled={disabledOne}
                    extraClass="d-flex align-items-center"
                    extraYesNo="f12-500"
                  />
                </div>
                {/* <Media query="(min-width:991px)"> */}
                <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                  {/* <Media query="(min-width:991px)"> */}
                  <div className="d-flex rightside-toggle-buttons-subscription-menu">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname: "/edit-ordering-subscription/curbside",
                          state: { access: "view" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname: "/edit-ordering-subscription/curbside",
                          state: { access: "edit" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  </div>
                </div>
                {/* </Media> */}
              </div>
              {props.casualDiningService || props.multiDiningService ? (
                <div className="row align-items-center pb-4 ml-1">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Dine-In / Order Ahead</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningDineIn}
                      checkedBox={state.casualFineDiningDineIn}
                      onChange={onClickDineInService}
                      disabled={disabledTwo}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                    />
                  </div>
                  {/* <Media query="(min-width:991px)"> */}
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    <div className="d-flex rightside-toggle-buttons-subscription-menu">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/dinein",
                            state: { access: "view" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/dinein",
                            state: { access: "edit" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                  {/* </Media> */}
                </div>
              ) : null}
              {props.fastFoodDiningService || props.multiDiningService ? (
                <div className="row align-items-center pb-4 ml-1">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">
                      Self Serve / SkipTheLine / Order Ahead
                    </div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningSkipline}
                      checkedBox={state.casualFineDiningSkipline}
                      onChange={onClickSkipTheLineService}
                      disabled={disabledSeven}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                    />
                  </div>
                  {/* <Media query="(min-width:991px)"> */}
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    <div className="d-flex rightside-toggle-buttons-subscription-menu">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/skiptheline",
                            state: { access: "view" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/skiptheline",
                            state: { access: "edit" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                  {/* </Media> */}
                </div>
              ) : null}
              {props.fastFoodDiningService || props.multiDiningService ? (
                <div className="row align-items-center pb-4 ml-1">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">At My Seat or Table Order</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningAtMySeat}
                      checkedBox={state.casualFineDiningAtMySeat}
                      onChange={onClickAtMySeatService}
                      disabled={disabledEight}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                    />
                  </div>
                  {/* <Media query="(min-width:991px)"> */}
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    <div className="d-flex rightside-toggle-buttons-subscription-menu">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/atmyseat",
                            state: { access: "view" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname: "/edit-ordering-subscription/atmyseat",
                            state: { access: "edit" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                  {/* </Media> */}
                </div>
              ) : null}
              <div className="row align-items-center pb-4 ml-1">
                <div className="col-4 col-md-7 col-lg-6 p-0">
                  <div className="f14-700">Catering and Banquet Services</div>
                </div>
                <div className="col-4 col-md-2 col-lg-3">
                  <ToggleButtonWithYesNo
                    activeClass={state.casualFineDiningCateringAndBanquet}
                    checkedBox={state.casualFineDiningCateringAndBanquet}
                    onChange={onClickCateringAndBanquetService}
                    disabled={disabledThree}
                    extraClass="d-flex align-items-center"
                    extraYesNo="f12-500"
                  />
                </div>
                {/* <Media query="(min-width:991px)"> */}
                <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                  <div className="d-flex rightside-toggle-buttons-subscription-menu">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname:
                            "/edit-ordering-subscription/catering-banquet",
                          state: { access: "view" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname:
                            "/edit-ordering-subscription/catering-banquet",
                          state: { access: "edit" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  </div>
                </div>
                {/* </Media> */}
              </div>
              {props.casualDiningService ||
              props.fastFoodDiningService ||
              props.multiDiningService ? (
                <div className="row align-items-center pb-4 ml-1">
                  <div className="col-4 col-md-7 col-lg-6 p-0">
                    <div className="f14-700">Home Delivery Order</div>
                  </div>
                  <div className="col-4 col-md-2 col-lg-3">
                    <ToggleButtonWithYesNo
                      activeClass={state.casualFineDiningHomeDelivery}
                      checkedBox={state.casualFineDiningHomeDelivery}
                      onChange={onClickHomeDeliveryService}
                      disabled={disabledFour}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                    />
                  </div>
                  {/* <Media query="(min-width:991px)"> */}
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    <div className="d-flex rightside-toggle-buttons-subscription-menu">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname:
                              "/edit-ordering-subscription/home-delivery",
                            state: { access: "view" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname:
                              "/edit-ordering-subscription/home-delivery",
                            state: { access: "edit" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                  {/* </Media> */}
                </div>
              ) : null}
              <div className="row align-items-center pb-4 ml-1">
                <div className="col-4 col-md-7 col-lg-6 p-0">
                  <div className="w-75 f14-700">
                    Maintain Separate Bank Accounts For Payment & Disbursement
                    for Orders
                  </div>
                  <Media query="(min-width:991px)">
                    <div className="w-75 d-flex align-items-center mt-2">
                      <div className="text-center" style={{ width: "8%" }}>
                        <i
                          class="fa fa-exclamation"
                          style={{
                            fontSize: "13px",
                            color: "#EF401B",
                            border: "1px solid #EF401B",
                            fontWeight: "lighter",
                            padding: "1px 5px",
                            borderRadius: "50%",
                          }}
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div
                        className="f10-400"
                        style={{ width: "92%", color: "#EF401B" }}
                      >
                        If you do not maintain bank account for now you will
                        need to maintain that later in session settings.
                      </div>
                    </div>
                  </Media>
                </div>
                <div className="col-4 col-md-2 col-lg-3">
                  <ToggleButtonWithYesNo
                    activeClass={state.casualFineDiningBankAccounts}
                    checkedBox={state.casualFineDiningBankAccounts}
                    onChange={onClickBankAccountsService}
                    disabled={disabledFive}
                    extraClass="d-flex align-items-center"
                    extraYesNo="f12-500"
                  />
                </div>
                {/* <Media query="(min-width:991px)"> */}
                <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                  <div className="d-flex rightside-toggle-buttons-subscription-menu">
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname:
                            "/edit-ordering-subscription/separate-bank-account",
                          state: { access: "view" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        history.push({
                          pathname:
                            "/edit-ordering-subscription/separate-bank-account",
                          state: { access: "edit" },
                        });
                      }}
                    >
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>
                  </div>
                </div>
                {/* </Media> */}
              </div>
              <div className="row align-items-center pb-4 ml-1">
                <div className="col-4 col-md-7 col-lg-6 p-0">
                  <div className="f14-700">Order General Settings Taxes*</div>
                </div>
                <div className="col-4 col-md-2 col-lg-3">
                  <ToggleButtonWithYesNo
                    activeClass={state.casualFineDiningGeneralSettings}
                    checkedBox={state.casualFineDiningGeneralSettings}
                    onChange={onClickGeneralSettingsService}
                    disabled={disabledSix}
                    extraClass="d-flex align-items-center"
                    extraYesNo="f12-500"
                  />
                </div>
                {!disabledSix && 
                  <div className="col-lg-3 col-md-3 col-4 mobile-p-0">
                    <div className="d-flex rightside-toggle-buttons-subscription-menu">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={(e) => {
                          history.push({
                            pathname:
                              "/edit-ordering-subscription/order-general-taxes",
                            state: { access: "view" },
                          });
                        }}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={onClickRedirectToOtherScreen}
                      >
                        <Image
                          src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                }
                {/* </Media> */}
              </div>
              <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                  Define Ordering Steps
                    <div className="f11-400 opacity5">
                    By selecting that the Merchant makes, will be applicable for all the types of services that he is offering
                    </div>
                  </div>

                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                name="delivery_partner"
                                id="delivery_partner"
                                className={`w-100`}
                                onChange={(e) => setState({...state,orderingsteps:e.target.value})}
                                value={state.orderingsteps}
                                //onBlur={formik.handleBlur}
                                IconComponent={KeyboardArrowDownIcon}
                                disabled={disabled}
                              >
                                {OrderingStepOptions &&
                                  OrderingStepOptions.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                        
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              <div className="row">
                <div className="col-12">
                  <MassCompletion
                    MassCompletionToggle={(e) => massCompletionToggle()}
                    massCompletionValue={state.massCompletion}
                    handleChange={(e) => onChangeMassCompletion(e)}
                    massCompletionTime={state.massCompletionTime}
                  />
                </div>
              </div>
              <br />
              <div
                className="onboarding-map-setup-screen-autodetect-button pt-4"
                style={{ marginBottom: "50px" }}
              >
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Back"
                  link="/profile"
                />
                {!disabled && (
                  <ReusableOnboardingButton
                    buttonTitle="Done Button"
                    disabled={disabled}
                    buttonClass={
                      // state.casualFineDiningBankAccounts === true &&
                      props.onboarding?.pos?.restId !== "" ||  state.casualFineDiningGeneralSettings === true
                        ? "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                        : "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                    }
                    buttonText="Done"
                    buttonType="button"
                    onClick={
                      // state.casualFineDiningBankAccounts === true &&
                      props.onboarding?.pos?.restId !== ""  ||
                      state.casualFineDiningGeneralSettings === true
                        ? orderingClickSubmitHandler
                        : null
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </React.Fragment>
  );
};

EditCasualDiningOrdering.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  get_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.ordering
      : state?.onboarding?.onboard_subscription_details?.fast_food_dining &&
        state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
          ?.ordering
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.ordering,
  allSubscriptionsData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
    restaurantDetails:
      state?.onboarding?.restaurantDetails,
  onboarding: state?.onboarding && state?.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  get_new_subscription_for_vendor,
})(withRouter(EditCasualDiningOrdering));
